import { render, staticRenderFns } from "./s5_index.vue?vue&type=template&id=69475e25&scoped=true&"
import script from "./s5_index.vue?vue&type=script&lang=js&"
export * from "./s5_index.vue?vue&type=script&lang=js&"
import style0 from "./s5_index.vue?vue&type=style&index=0&id=69475e25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69475e25",
  null
  
)

export default component.exports